// @flow strict

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';


export default function useLabelTranslation(): (
  key: string,
  defaultValue: string,
) => string {
  const {labelI18nInstance} = useI18n();
  return labelI18nInstance.t;
}
